import { useTranslation } from 'react-i18next';
import {
  Box,
  Typography,
  List,
  ListItem,
  ListItemButton,
  ListItemIcon,
  ListItemText,
} from '@mui/material';
import {
  Wifi as WifiIcon,
  Cable as CableIcon,
  Info as InfoIcon,
  PhoneAndroid as PhoneAndroidIcon,
} from '@mui/icons-material';
import NetworkRetest from './NetworkRetest';

function NetworkNotGood({ explanationText }) {
  const { t } = useTranslation();
  return (
    <>
      <Box display="flex" justifyContent="center" marginBottom="16px">
        <img
          src="network-quality-medium.png"
          alt="network quality not good"
          width={200}
          style={{ maxWidth: '100vW' }}
        />
      </Box>
      <Box sx={{ maxWidth: '375px' }}>
        <Typography variant="h5" gutterBottom align="center">
          {t('Your Call will be choppy: Try these tips.')}
        </Typography>
      </Box>
      <Box sx={{ maxWidth: '375px' }}>
        <Typography fontSize="14px" gutterBottom>
          {t(explanationText)}
        </Typography>
      </Box>
      <Box sx={{ maxWidth: '375px' }}>
        <List dense={true} sx={{ paddingBottom: '0px', paddingTop: '0px' }}>
          <ListItem disablePadding>
            <ListItemButton>
              <ListItemIcon>
                <WifiIcon fontSize="small" />
              </ListItemIcon>
              <ListItemText
                primary={
                  <Typography fontSize="14px">
                    {t(
                      "Switch Wi-Fi networks or use your smartphone's hotspot(Such as 4G)"
                    )}
                  </Typography>
                }
              />
            </ListItemButton>
          </ListItem>
          <ListItem disablePadding>
            <ListItemButton>
              <ListItemIcon>
                <CableIcon fontSize="small" />
              </ListItemIcon>
              <ListItemText
                primary={
                  <Typography fontSize="14px">
                    {t('Move closer to the router or use an ethernet cable')}
                  </Typography>
                }
              />
            </ListItemButton>
          </ListItem>
          <ListItem disablePadding>
            <ListItemButton>
              <ListItemIcon>
                <InfoIcon fontSize="small" />
              </ListItemIcon>
              <ListItemText
                primary={
                  <Typography fontSize="14px">
                    {t(
                      'Make sure no one is downloading or streaming using your Wi-Fi'
                    )}
                  </Typography>
                }
              />
            </ListItemButton>
          </ListItem>
          <ListItem disablePadding>
            <ListItemButton>
              <ListItemIcon>
                <PhoneAndroidIcon fontSize="small" />
              </ListItemIcon>
              <ListItemText
                primary={
                  <Typography fontSize="14px">
                    {t('Switch device or browser')}
                  </Typography>
                }
              />
            </ListItemButton>
          </ListItem>
        </List>
      </Box>
      <NetworkRetest />

      <Box
        display="flex"
        justifyContent="center"
        marginBottom="16px"
        mt={2}
        sx={{ maxWidth: '375px' }}
      >
        <Typography gutterBottom fontSize={'small'}>
          <b>{t('Did you know?')} </b>
          {t(
            'You can refresh the page or turn off your camera during your video call to improve the quality.'
          )}
        </Typography>
      </Box>
    </>
  );
}

export default NetworkNotGood;
